// Auto-updated by scripts/bump-version.js
export const APP_VERSION = '1.1.0';
